import { useEffect, useState } from "react";
import ChecklistForm from "./ChecklistForm";
import {
  getChecklists,deleteChecklists,
} from "../../../services/api/qa/checklistService";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { toast } from "react-hot-toast";

function ChecklistList() {
  const [checklists, setChecklists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [selectedChecklist, setSelectedChecklist] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const navigate = useNavigate();

  // Fetch Data
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getChecklists();
      setChecklists(res || []);
    } catch (err) {
      console.error("Error fetching checklists", err);
      toast.error("Failed to load checklists");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Confirm Delete
  const confirmDelete = async () => {
    try {
      await deleteChecklists(selectedId);

      toast.success("Checklist deleted successfully");

      fetchData();
    } catch (error) {
      toast.error("Failed to delete checklist");
    } finally {
      setShowDeleteModal(false);
      setSelectedId(null);
    }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold">
          Checklist Management
        </h2>

        <button
          onClick={() => {
            setSelectedChecklist(null);
            setOpenForm(true);
          }}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          + Create Checklist
        </button>
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="bg-white shadow rounded">
          <table className="w-full border text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-3 border">#</th>
                <th className="p-3 border text-left">Name</th>
                <th className="p-3 border">Status</th>
                <th className="p-3 border text-center">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {checklists.length > 0 ? (
                checklists.map((item, index) => (
                  <tr
                    key={item.id}
                    className="hover:bg-gray-50"
                  >
                    <td className="p-3 border">
                      {index + 1}
                    </td>

                    <td className="p-3 border">
                      {item.name}
                    </td>

                    <td className="p-3 border text-center">
                      <span
                        className={`px-2 py-1 rounded text-white text-xs ${
                          item.status === "active"
                            ? "bg-green-500"
                            : "bg-gray-400"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>

                    <td className="p-3 border">
                      <div className="flex justify-center gap-4">
                        {/* View */}
                        <button
                          onClick={() =>
                            navigate(
                              `/checklists/view/${item.id}`
                            )
                          }
                          className="text-blue-600 hover:text-blue-800"
                          title="View"
                        >
                          <FaEye size={16} />
                        </button>

                        {/* Edit */}
                        <button
                          onClick={() => {
                            setSelectedChecklist(item);
                            setOpenForm(true);
                          }}
                          className="text-green-600 hover:text-green-800"
                          title="Edit"
                        >
                          <FaEdit size={16} />
                        </button>

                        {/* Delete */}
                        <button
                          onClick={() => {
                            setSelectedId(item.id);
                            setShowDeleteModal(true);
                          }}
                          className="text-red-600 hover:text-red-800"
                          title="Delete"
                        >
                          <FaTrash size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="text-center p-4 text-gray-500"
                  >
                    No checklists found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Create / Edit Modal */}
      {openForm && (
        <ChecklistForm
          checklist={selectedChecklist}
          onClose={() => {
            setOpenForm(false);
            setSelectedChecklist(null);
          }}
          onSuccess={() => {
            fetchData();
            setOpenForm(false);
          }}
        />
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg shadow-lg w-96 p-6">
            <h3 className="text-lg font-semibold mb-4">
              Confirm Delete
            </h3>

            <p className="text-gray-600 mb-6">
              Are you sure you want to delete this
              checklist? This action cannot be undone.
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() =>
                  setShowDeleteModal(false)
                }
                className="px-4 py-2 border rounded hover:bg-gray-100"
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChecklistList;